import React, { FunctionComponent } from 'react'

import { CDN_ASSETS_LINK_BASE } from '@lyrahealth-inc/shared-app-logic'

import { Image } from '../image/Image'

interface ExperienceWithCareIllustrationProps {
  width?: number
  height?: number
}

export const ExperienceWithCareIllustration: FunctionComponent<ExperienceWithCareIllustrationProps> = ({
  width = 184,
  height = 125,
  ...props
}) => {
  return (
    <Image
      source={{ uri: `${CDN_ASSETS_LINK_BASE}/experienceWithCare.png` }}
      style={{ width, height }}
      contentFit='contain'
      accessibilityIgnoresInvertColors
      {...props}
    />
  )
}
